import { render, staticRenderFns } from "./OpenboxDocuments.vue?vue&type=template&id=4c2ff3f3&"
import script from "./OpenboxDocuments.vue?vue&type=script&lang=js&"
export * from "./OpenboxDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports